<template>
  <div v-if="bannerFlags.hasAnyBanner" :class="['loyalty-celebration-flourishes', flourishClass]">
    <img v-if="starRewardsBanners[BANNER_KEYS.desktop]" class="flourish-image desktop-flourish" :src="getImageUrl('desktop')" alt="" />
    <img v-if="starRewardsBanners[BANNER_KEYS.tablet]" class="flourish-image tablet-flourish" :src="getImageUrl('tablet')" alt="" />
    <img v-if="starRewardsBanners[BANNER_KEYS.mobile]" class="flourish-image mobile-flourish" :src="getImageUrl('mobile')" alt="" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useDashboardStore } from '@/stores/useDashboardStore';
import { BANNER_KEYS, getFlourishBannerFlags } from '@/utils/loyalty';

const dashboardStore = useDashboardStore();
const { starRewardsBanners } = storeToRefs(dashboardStore);

const bannerFlags = computed(() => getFlourishBannerFlags(starRewardsBanners.value));
const flourishClass = computed(() => (bannerFlags.value.isDecember ? 'flourish-full-width' : 'flourish-centered'));

const getImageUrl = (deviceType) => {
  return starRewardsBanners.value[BANNER_KEYS[deviceType]] + '?fmt=webp-alpha';
};
</script>

<style lang="scss" scoped>
.loyalty-celebration-flourishes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
}

.flourish-image {
  position: absolute;
  pointer-events: none;
  transition: opacity 0.3s ease;
  display: none;
  top: 0;
}

/* Centered flourish positioning */
.flourish-centered {
  /* Desktop Viewport */
  @include breakpoint(large up) {
    .desktop-flourish {
      display: block;
      left: 24.4%;
      width: rem-calc(404);
      height: 100%;
    }
  }

  /* Tablet Viewport */
  @include breakpoint(medium only) {
    .tablet-flourish {
      display: block;
      left: 33.8%;
      width: rem-calc(254);
      height: rem-calc(143);
    }
  }

  /* Mobile Viewport */
  @include breakpoint(small down) {
    .mobile-flourish {
      display: block;
      left: 50.2%;
      width: rem-calc(119);
      height: rem-calc(88);
    }
  }
}

/* Full-width flourish positioning */
.flourish-full-width {
  /* Desktop Viewport */
  @include breakpoint(large up) {
    .desktop-flourish {
      display: block;
      left: 4%;
      height: rem-calc(227);
    }
  }

  /* Tablet Viewport */
  @include breakpoint(medium only) {
    .tablet-flourish {
      display: block;
      left: 10%;
      height: rem-calc(223);
    }
  }

  /* Mobile Viewport */
  @include breakpoint(small down) {
    .mobile-flourish {
      display: block;
      left: 44.8%;
      width: rem-calc(150);
    }
  }
}
</style>
